import React from "react";

function PlantProgressBar({ plantTarget = 0, plantsCompleted = 0 }) {
  // Calculate percentage
  const percentage =
    plantTarget > 0
      ? Math.min((plantsCompleted / plantTarget) * 100, 100)
      : 0;

  // Format numbers with commas
  const formatNumber = (num) => {
    return num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Filled bar gradient style
  const filledStyle = {
    width: `${percentage}%`,
    height: "100%",
    background:
      "linear-gradient(to right, #ff4d6d,#ef233c, #f49f0a,#52b788,#40916c)",
    borderRadius: "20px 0 0 20px",
    transition: "1s ease-in",
  };

  return (
    <div style={{ width: "100%", margin: "30px 0" }}>
      {/* <h3
        style={{
          marginBottom: "10px",
          color: "#40916c",
          fontWeight: "bold",
        }}
      >
        Plant Progress
      </h3> */}

      {/* Progress Bar */}
      <div
        style={{
          backgroundColor: "#d8d8d8",
          borderRadius: "20px",
          height: "30px",
          width: "100%",
          display: "flex",
          alignItems: "center",
        //   overflow: "hidden",
        }}
      >
        {/* Filled gradient */}
        <div style={filledStyle}></div>

        {/* Separator */}
        <div
          style={{
            border: "2px solid #585151",
            backgroundColor: "#edf754",
            borderRadius: "4px",
            height: "35px",
            width: "10px",
            zIndex: 10,
            marginLeft: "-4px",
          }}
        ></div>
      </div>

      {/* Values section */}
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "8px",
          fontWeight: "bold",
              color: "#a52a2a",
           fontSize: "20px",
        }}
      >
        <span>
          {plantsCompleted
            ? `${formatNumber(plantsCompleted)} Planted`
            : "0 Planted"}
        </span>

        <span>
          {plantTarget
            ? `${formatNumber(plantTarget)} Target`
            : "0 Target"}
        </span>
      </div>
    </div>
  );
}

export default PlantProgressBar;
